/* v05_a24-dawn-refactor/assets/a24-footer-withdrawal-modal.js */
(() => {
  const modal = document.querySelector('[data-a24-footer-withdrawal-modal]');
  if (!modal) return;

  const openButtons = document.querySelectorAll('[data-a24-footer-withdrawal-open]');
  const closeButtons = modal.querySelectorAll('[data-a24-footer-withdrawal-close]');
  const firstField = modal.querySelector('input, textarea, button');
  let lastActiveElement = null;

  const openModal = () => {
    lastActiveElement = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('footer-withdrawal-modal-is-open');
    window.setTimeout(() => {
      modal.classList.add('is-open');
      if (firstField) firstField.focus({ preventScroll: true });
    }, 0);
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('footer-withdrawal-modal-is-open');
    window.setTimeout(() => {
      modal.hidden = true;
      if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
        lastActiveElement.focus({ preventScroll: true });
      }
    }, 160);
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', openModal);
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });

  if (window.location.hash === '#a24-footer-withdrawal-modal') {
    openModal();
  }
})();
